module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAA90lEQVRIx2NgmLn1PzoWXbj7PzZxltnbsdI0xcgcqcV7/+99+ub/zsev/ztsOvFfZsleFMXZR67+Z5q17X/24SsQPpSmmwNbz935//7nr/9cc3egKOKYAwkpTqg4jIaJ082Bq+4++3/l3WcMRemHLv9nnb3tfxYwxBjBIQkNwSN0DkGnzSf+g0DsvgvgqFRZvh9MiwDTJMhhYosgaVN80R68aZVmDgRhtRUH/teevvnfZP3R/6G7z/3nnbcT7GBmoEMT9l8Eq0GnaYoXlbZtH8yY4f8gB6MOHHXgqAMJOTCv1W3bYMYMclut/g9mPOrAUQeOOpAABgA/MJCEVjOmSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/uz.png
// module id = 953
// module chunks = 0